import React from "react";
import IStepButtons from "./IStepButtons";
import { Spin } from "antd";

import * as style from "./StepButtonsStyle.module.scss"
import * as elements from "@appStyles/_elements.module.scss";

const StepButtons: React.SFC<IStepButtons> = (props: IStepButtons) => {
  return (
    <div className={style.stepButtons}>
      {!props.isFirstStep && (
        <button
          onClick={props.prevStep}
          className={[elements.btn, elements.btnCancel].join(" ")}
          data-cy="back"
        >
          Back
        </button>
      )}
      {!props.nextHidden && (
        <button
          onClick={props.nextStep}
          disabled={!props.nextStepEnable}
          className={[elements.btn, style.nextBtn].join(" ")}
          data-cy="next"
        >
          {props.isLoading ? "In progress ..." : props.nextText}
          {props.isLoading && <Spin style={{ marginLeft: "20px" }} />}
        </button>
      )}
    </div>
  );
};

export default React.memo(StepButtons);
